/* ============================================================
   Personalización de productos — La Casita de los Regalos
   Previsualización de archivos y botón de quitar.
   Usa delegación de eventos para funcionar con cualquier
   número de campos y aunque el formulario se vuelva a pintar.
   ============================================================ */
(function () {
  'use strict';

  function pintarPreview(input) {
    var contenedor = input.closest('.perso-archivo');
    if (!contenedor) return;
    var preview = contenedor.querySelector('.perso-archivo__preview');
    var nombre = contenedor.querySelector('.perso-archivo__nombre');
    if (preview) preview.innerHTML = '';
    if (nombre) nombre.textContent = '';

    var file = input.files && input.files[0];
    if (!file) return;

    if (nombre) nombre.textContent = file.name;

    // Si es imagen, mostrar miniatura con botón de quitar.
    if (file.type && file.type.indexOf('image/') === 0) {
      var reader = new FileReader();
      reader.onload = function (e) {
        if (!preview) return;
        var item = document.createElement('div');
        item.className = 'perso-archivo__item';

        var img = document.createElement('img');
        img.src = e.target.result;
        img.alt = file.name;

        var quitar = document.createElement('button');
        quitar.type = 'button';
        quitar.className = 'perso-archivo__quitar';
        quitar.setAttribute('aria-label', 'Quitar imagen');
        quitar.innerHTML = '&times;';

        item.appendChild(img);
        item.appendChild(quitar);
        preview.appendChild(item);
      };
      reader.readAsDataURL(file);
    }
  }

  function limpiar(contenedor) {
    if (!contenedor) return;
    var input = contenedor.querySelector('.perso-archivo__input');
    var preview = contenedor.querySelector('.perso-archivo__preview');
    var nombre = contenedor.querySelector('.perso-archivo__nombre');
    if (input) input.value = '';
    if (preview) preview.innerHTML = '';
    if (nombre) nombre.textContent = '';
  }

  // Selección de archivo
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('perso-archivo__input')) {
      pintarPreview(t);
    }
  });

  // Quitar imagen
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var quitar = e.target.closest('.perso-archivo__quitar');
    if (quitar) {
      e.preventDefault();
      limpiar(quitar.closest('.perso-archivo'));
    }
  });

  // Accesibilidad: abrir el diálogo con Enter/Espacio sobre el botón-etiqueta
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (
      (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') &&
      t && t.classList && t.classList.contains('perso-archivo__boton')
    ) {
      e.preventDefault();
      var contenedor = t.closest('.perso-archivo');
      var input = contenedor && contenedor.querySelector('.perso-archivo__input');
      if (input) input.click();
    }
  });
})();
